// hae asiakaslista ja laita järjestykseen prioriteetin mukaan
// laita ensimmäiseksi refLink numerot (asiakasnumerot)
// foreach asiakas
// foreach sijainti in asiakas
// jos sijainti->tyomaa distance < maxDistance niin return sijainti ja asiakas

import { checkResponse } from "src/components/js/statics1";
import { sijainti_calculateDistance, sijanti_getList } from "../SijaintiFunctions";

export async function findSijaintiForKeikkaFromAsiakasPriority(
  keikkaData,
  address,
  ownerAsiakasId,
  token,
  pumppuAsiakasId_refLink = null, // oletuksella valitaan tämä asiakas pumpputoimijaksi
  betoniAsiakasId_refLink = null, // oletuksella valitaan tämä asiakas betonitoimijaksi
  ignoreDistanceRestriction = false
) {
  if (!address) address = keikkaData.tyomaa.tyomaaOsoiteString;
  let betoniAsiakasId = null;
  let betoniSijaintiId = null;
  let betoniSijaintiKm = 1000;
  let betoniSijaintiLat = 0;
  let betoniSijaintiLng = 0;
  let pumppuAsiakasId = null;
  let pumppuSijaintiId = null;
  let pumppuSijaintiKm = 1000;
  let pumppuSijaintiLat = 0;
  let pumppuSijaintiLng = 0;
  const tyomaa = keikkaData.tyomaa;
  const asiakasList = await getAsiakasPriorityList(address, ownerAsiakasId, token);

  // add refLink asiakasId to the top of the list
  if (pumppuAsiakasId_refLink) {
    asiakasList.splice(0, 0, {
      asiakasId: pumppuAsiakasId_refLink,
      sijaintiTypeId: 2,
      priority: 100,
      comment: "from getAsiakasPriorityList",
    });
  }
  // add refLink asiakasId to the top of the list
  if (betoniAsiakasId_refLink) {
    asiakasList.splice(0, 0, {
      asiakasId: betoniAsiakasId_refLink,
      sijaintiTypeId: 1,
      priority: 100,
      comment: "from getAsiakasPriorityList",
    });
  }
  const sijaintiList = await sijanti_getList("0", token);

  let betoniSijaintiFound = false;
  let pumppuSijaintiFound = false;
  // loop all customers
  for (let i = 0; i < asiakasList.length; i++) {
    const _asiakas = asiakasList[i];
    if (!betoniSijaintiFound || !pumppuSijaintiFound) {
      // loop all locations for customer
      for (let j = 0; j < sijaintiList.length; j++) {
        const _sijainti = sijaintiList[j];
        if (_asiakas.asiakasId == _sijainti.asiakasId) {
          const _linnunreittiKm = sijainti_calculateDistance(
            tyomaa.lat,
            tyomaa.lng,
            _sijainti.lat,
            _sijainti.lng
          );
          if (_linnunreittiKm < _sijainti.maxDeliveryDistance || ignoreDistanceRestriction) {
            if (
              !betoniSijaintiFound &&
              betoniSijaintiKm > _linnunreittiKm &&
              _sijainti.sijaintiTypeId === 1
            ) {
              betoniAsiakasId = _sijainti.asiakasId;
              betoniSijaintiId = _sijainti.sijaintiId;
              betoniSijaintiKm = _linnunreittiKm;
              betoniSijaintiLat = _sijainti.lat;
              betoniSijaintiLng = _sijainti.lng;
            }

            if (
              !pumppuSijaintiFound &&
              pumppuSijaintiKm > _linnunreittiKm &&
              _sijainti.sijaintiTypeId === 2
            ) {
              pumppuAsiakasId = _sijainti.asiakasId;
              pumppuSijaintiId = _sijainti.sijaintiId;
              pumppuSijaintiKm = _linnunreittiKm;
              pumppuSijaintiLat = _sijainti.lat;
              pumppuSijaintiLng = _sijainti.lng;
            }
          }
        }
      }
      if (betoniSijaintiId && betoniAsiakasId) {
        betoniSijaintiFound = true;
      }
      if (pumppuSijaintiId && pumppuAsiakasId) {
        pumppuSijaintiFound = true;
      }
    }
  }
  return [
    {
      betoniAsiakasId: betoniAsiakasId,
      betoniSijaintiId: betoniSijaintiId,
      betoniSijaintiKm: betoniSijaintiKm,
      betoniSijaintiLat: betoniSijaintiLat,
      betoniSijaintiLng: betoniSijaintiLng,
      pumppuAsiakasId: pumppuAsiakasId,
      pumppuSijaintiId: pumppuSijaintiId,
      pumppuSijaintiKm: pumppuSijaintiKm,
      pumppuSijaintiLat: pumppuSijaintiLat,
      pumppuSijaintiLng: pumppuSijaintiLng,
    },
  ];
}

export async function getAsiakasPriorityList(address, ownerAsiakasId, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
      "Cache-Control": 360,
    },
    body: JSON.stringify({
      address: address,
      ownerAsiakasId: ownerAsiakasId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/geocode/getAsiakasPriorityList",
    requestOptions
  ).catch((error) => {
    console.log(error);
    return error;
  });
  const a = await checkResponse(response, "getAsiakasPriorityList.js");
  return a.data;
}
